export const feeFinancableTransactionTypes = new Set([
  'FINALE HANDOVER PAYMENT',
  'BUY A PROPERTY',
  'HANDOVER RESALE'
]);

export const emiratesSupportFeeFinancing = new Set([
  'dubai',
  'abu_dhabi',
  'ajman',
  'ras_al_khaimah',
  'umm_al_quwain',
  'sharjah'
]);

export const EmirateType = {
  dubai: 'Dubai',
  abu_dhabi: 'Abu Dhabi',
  sharjah: 'Sharjah',
  ajman: 'Ajman',
  ras_al_khaimah: 'Ras Al Khaimah',
  fujairah: 'Fujairah',
  umm_al_quwain: 'Umm Al Quwain',
} as const;
